import state from './module-taxpayerinfo-state';
import mutations from './module-taxpayerinfo-mutations';
import actions from './module-taxpayerinfo-actions';
import getters from './module-taxpayerinfo-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
